import { useEffect } from 'react';

import { FullStory } from '@fullstory/browser';
import { useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';

import { useProjectTreeStore } from 'store/projectContract.store';
import { useUserStore } from 'store/user.store';

import { IGetUserDetailResponse } from 'api/queries/getUserDetail.query';

export const useLoginHook = ({
    user,
    isSwitchUser,
}: {
    user: IGetUserDetailResponse | undefined;
    isSwitchUser: boolean;
}) => {
    const url = new URL(document.URL);
    const history = useHistory();
    const { update: updateUser } = useUserStore();
    const { update: updateProject } = useProjectTreeStore();
    const queryClient = useQueryClient();

    useEffect(() => {
        if (user) {
            updateUser({ user, isSwitchUser });
            if (isSwitchUser) {
                updateProject({
                    project: null,
                    contract: null,
                    parentNode: null,
                    currentList: [],
                });
                queryClient.clear();
            }

            FullStory('setIdentity', {
                uid: user.username,
                properties: {
                    displayName: `${user.firstName} ${user.lastName}`,
                    email: user.username,
                    customerId: user.customerId,
                    username: user.username,
                    domain: url.hostname,
                },
            });
            const redirectSplit = window.location.href.split('redirect=');
            const redirect = redirectSplit.length > 1 ? redirectSplit[1] : undefined;
            history.push(redirect ?? '/');
        }
    }, [history, isSwitchUser, updateProject, updateUser, url.hostname, user, queryClient]);
};
